<div class="copilot-message-container" *ngIf="followUpQuestions?.length">
  <div class="copilot-message-content">
    <div class="questions-container">
      <br>
      Would you like me to answer any of these questions next?
      <br>
      <br>
      <div class="question-container" [class.selected]="question===selectedQuestion" *ngFor="let question of followUpQuestions">
        <div class="question-content" (click)="sendQuestion(question)">{{ question }}</div>
      </div>
    </div>
  </div>
</div>
